// src/models/saleModel.js - Frontend Sale Model
import api from '../services/api';

// Create a new sale (buyer + apartment + payment plan)
export const createSale = async (saleData) => {
    try {
        const response = await api.post('/sales', saleData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error creating sale' };
    }
};

// Get all sales
export const getAllSales = async (filters = {}) => {
    try {
        const response = await api.get('/sales', { params: filters });
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error fetching sales' };
    }
};

// Get single sale with installments
export const getSale = async (id) => {
    try {
        const response = await api.get(`/sales/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error fetching sale' };
    }
};

// Record a payment on an installment
export const recordInstallmentPayment = async (saleId, paymentData) => {
    try {
        const response = await api.post(`/sales/${saleId}/payments`, paymentData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error recording payment' };
    }
};

// Update a single installment (admin: amount and/or dueDate)
export const updateInstallment = async (saleId, installmentId, data) => {
    try {
        const response = await api.put(`/sales/${saleId}/installments/${installmentId}`, data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error updating installment' };
    }
};

// Delete a sale
export const deleteSale = async (id) => {
    try {
        const response = await api.delete(`/sales/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error deleting sale' };
    }
};

// Format currency
export const formatCurrency = (amount, currency = 'USD') => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount || 0);
};

// Get payment status badge info
export const getPaymentStatusInfo = (status) => {
    switch (status) {
        case 'paid':
            return { label: 'Paid', color: 'green' };
        case 'partial':
            return { label: 'Partial', color: 'yellow' };
        default:
            return { label: 'Unpaid', color: 'red' };
    }
};

export default {
    createSale,
    getAllSales,
    getSale,
    recordInstallmentPayment,
    updateInstallment,
    deleteSale,
    formatCurrency,
    getPaymentStatusInfo
};
